import axios from 'axios'

export default {
  namespaced: true,

  actions: {
    getLevelsVisor({
      rootGetters
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/getbybranchforvisor?id=" + rootGetters.getBranch.id,
          method: 'GET'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLevels({
      rootGetters
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/getbybranch?id=" + rootGetters.getBranch.id,
          method: 'GET'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLevelsTools() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/tools",
          method: 'GET'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getGgByLevel(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/gradegroup/web/getbylevel?id=" + id,
          method: 'GET'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    createLevel(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/create",
          data: obj,
          method: 'POST'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateLevel(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/update",
          data: obj,
          method: 'PUT'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteLevel(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/delete?id=" + obj.id,
          method: 'DELETE'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLevelsByIdBranch(o, id){
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/level/web/getbybranch?id=" + id,
          method: 'GET'
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}